import React, { ChangeEvent, ReactNode, useContext } from 'react';

import { FormOptionsFieldContext } from './FormOptionsField';
import { useFormField } from './useFormField';

export interface IFormOptionValueProps {
  value: string;
  children: ReactNode | ReactNode[];
}

function FormOptionValue({ children, value }: IFormOptionValueProps) {
  const { name, type } = useContext(FormOptionsFieldContext);
  const { id, inputProps, meta, setValue } = useFormField<string | string[]>(name);

  const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (type === 'radio' && event.target.checked) {
      await setValue(value);
    } else if (type === 'checkbox') {
      await setValue(
        event.target.checked
          ? [...(meta.value ?? []), value]
          : (meta.value as string[])?.filter((v) => v !== value),
      );
    }
  };

  return (
    <div className="modFormOptionValue">
      <input
        id={id}
        className={inputProps.className}
        value={value}
        type={type}
        onChange={onChange}
        checked={meta.value?.includes(value)}
        style={{ display: 'none' }}
      />
      <label className="modFormOptionValue__label" htmlFor={id}>
        {children}
      </label>
    </div>
  );
}

export default FormOptionValue;
